const onlimeGsmCards = {
    id: "onlimeGsm",
    grid: { cols: { base: 1, sm: 2, lg: 2 }, gap: "var(--spacing-4)" },
    items: [
        {
            id: "onlimeGsm-1",
            type: "onlimeGsm",
            title: "Контроль и спокойствие",
            text: "Вы всегда знаете, когда приедет топливо, и можете планировать работу техники, исключая внезапные задержки."
        },
        {
            id: "onlimeGsm-2",
            type: "onlimeGsm",
            title: "Доверие",
            text: "Система исключает возможность махинаций с маршрутом или сливом топлива – мы видим весь путь цистерны.",
        },    
    ],
};

export default onlimeGsmCards;





